type Membership = {
  organization?: { id?: string } | string;
  organization_id?: string;
  role?: string;
  is_active?: boolean;
};

type StoredUser = {
  is_superuser?: boolean;
  is_staff?: boolean;
  organization_memberships?: Membership[];
};

export function getOrgsWhereUserIsAdmin(user?: StoredUser | null): string[] {
  const u = user ?? null;
  if (!u) return [];
  return (u.organization_memberships ?? []).flatMap((m) => {
    if (!m.is_active || m.role !== "ORG_ADMIN") return [];
    const org =
      typeof m.organization === "string"
        ? m.organization
        : (m.organization?.id ?? m.organization_id ?? "");
    return org ? [org] : [];
  });
}
